export default "__VITE_ASSET__DKRsB3RQ__"